import { render } from "./TimesheetPeriod.vue?vue&type=template&id=008d2988&scoped=true"
import script from "./TimesheetPeriod.vue?vue&type=script&lang=js"
export * from "./TimesheetPeriod.vue?vue&type=script&lang=js"

import "./timesheet-period.scss?vue&type=style&index=0&id=008d2988&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008d2988"]])

export default __exports__